export default {
    titleColon: true,
    titleAlign: 'right',
    titleWidth: '140',
    validConfig: {
        autoPos: true,
        // theme: 'simple', // simple|bright
        showErrorMessage: false,
        showErrorIcon: true,
    },
};
